module.exports = __webpack_public_path__ + "static/leaf right-32fd917ff63d0e3f40aae53616271726.png";